import React from 'react';
import {
  Alert,
} from 'react-bootstrap';
import PMono from './p/PMono'
//import PText from './p/PText'
//import PTextLabel from './p/PTextLabel'
//import utils from '../utils'

export default class EcuMessageResult extends React.Component {
  //constructor(props) {    
  //  super(props)    
  //}  
  render() {
    if (this.props.data === undefined) 
      return ""

    if (this.props.data === 0) {
      return (
        <>           
          <Alert variant="success">
            <Alert.Heading>OK</Alert.Heading>
          </Alert>
        </>
      )
    }
    return (
      <>          
        <Alert variant="danger">
          <Alert.Heading>WARNING</Alert.Heading>
          <PMono value={this.props.data} />
        </Alert>
      </>
    )
  }
}